<template>
  <div id="app">
    <div class="case_div">
      <img class="home_banner" src="../../static/img/img_case_detail_bg.png" />
      <!-- <div class="div_top_title">
        <p>服务案例</p>
        <p class="p_title_sub">SERVICE CASE</p>
      </div> -->
    </div>
    <div class="father-div">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="8" :lg="8">
          <div class="logo-div">
            <img :src="Detail.cover" />
          </div>
          <div class="back-div" @click="back()">
            <p>返回列表</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="16" :lg="16">
          <div class="title-div">
            <div class="logo-div">
              <img :src="Detail.cover" />
            </div>
            <p class="subtitle">{{ Detail.subtitle }}</p>
            <p class="title">{{ Detail.title }}</p>
            <div class="line"></div>
          </div>
          <div v-html="Detail.content" class="content"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      Detail: [],
      showBottomImg: true,
    };
  },
  mounted: function () {
    this.getDetail();
  },

  watch: {
    //监听路由变化
    $route(to, from) {
      window.scrollTo(0, 0);
      console.log(to.path);
      console.log(from.path);
      this.getDetail();
    },
  },
  methods: {
    getEleWidth() {
      var a = $("#toptitle").outerWidth(true), //width()返回元素的宽高，不包括padding/border/margin
        b = $("#topsubtitle").outerWidth(true);
      console.log(a, b);
      this.setEleWidth(a + b);
    },
    removeElemargin() {
      var a = $("#topsubtitle").css("margin-left", 0);
      console.log(a);
    },
    setEleWidth(a, b) {
      if (b > 20) {
        $("#litter_line_top").width(a + b - 20);
      } else {
        $("#litter_line_top").width(a - 20);
      }
    },
    getDetail() {
      this.$axios
        .get("api/safecase/info", {
          params: {
            id: window.location.href.split("id=")[1],
            plate: sessionStorage.getItem("plate"),
            business: sessionStorage.getItem("business"),
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.Detail = response.data.data;
              if (this.Detail.midLeftBottomImg) {
                this.showBottomImg = true;
              } else {
                this.showBottomImg = false;
              }
              document.title = this.Detail.title;
              setTimeout(() => {
                var sub = this.Detail.subtitle;
                if (!sub && typeof sub != "undefined" && sub != 0) {
                  //判断null
                  this.removeElemargin();
                }
                // this.getEleWidth();
              }, 1000);
            }
          }.bind(this)
        );
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.case_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.cover_div {
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 0);
  top: 0;
  left: 0;
}

.div_top_title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 50%;
  height: 100%;
  right: 0;
  top: 0;
  color: var(--COLORE182347);
  font-size: 4rem;
  font-family: medium;
  p{
    margin-bottom:0;
    user-select: none;
  }

  .p_title_sub {
    position: absolute;
    font-size: 8rem;
    font-family: DIN-Bold;
    margin: 0 1rem;
    color:var(--COLORE18234733);
  }

  .litter_line_top {
    margin: auto;
    background-color: white;
    height: 1px;
    width: 20%;
  }
}

.father-div {
  padding: 9rem 24rem;
}

.logo-div {
  padding: 1rem;
  width: 32rem;
  height: 9rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-radius: 6px;
  -webkit-box-shadow: 3px 3px 10px 1px rgba(100, 100, 100, 0.1);
  box-shadow: 3px 3px 10px 1px rgba(100, 100, 100, 0.1);

  img {
    height: 100%;
  }
}

.back-div {
  cursor: pointer;
  margin-top: 11rem;
  width: 15rem;
  border-radius: 5rem;
  color: white;
  background: var(--COLORE14B3E3);
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);

  p {
    margin: 0;
    font-size: 1.8rem;
  }
}

.title-div {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  .logo-div{
    display: none;
  }
  .subtitle {
    color: var(--COLORE17);
    font-family: DIN-Bold;
    font-size: 4.8rem;
    line-height: 1;
  }

  .title {
    color: var(--COLORE3A);
    font-family: medium;
    font-size: 2.4rem;
    line-height: 1;
    margin: 0;
  }
}

.line {
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
  height: 1px;
  width: 100%;
  background: var(--COLOREAB);
}

.content {
  color: var(--COLORE47);
  font-family: regular;
  font-size: 1.8rem;
  text-align: start;
  line-height: 1.5;

  p {
    margin: 0;
  }
}
@media screen and (max-width: 1200px) {
  .father-div{
    padding: 9rem 1rem;
    height: 100vh;
  }
  .logo-div{
    display: none;
  }
  .el-row{
    display: flex;
    flex-direction: column-reverse;
  }
  .title-div{
    .logo-div{
      display: block;
    }
    .subtitle{
      margin-top:1rem;
    }
  }
}
</style>
